export function Thunder(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="12"
        height="22"
        viewBox="0 0 12 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.74985 0H5.22356C4.0126 0 2.95436 0.808568 2.64868 1.96736L0.0446817 11.8391C0.0150155 11.9516 0 12.0673 0 12.1836L0.00631634 12.315C0.0731766 13.007 0.662583 13.5481 1.3798 13.5481H3.60831L2.1605 20.3542C2.04233 20.9093 2.28377 21.4788 2.76692 21.7846C3.40877 22.1908 4.26209 22.0056 4.67287 21.3708L11.7824 10.385C11.9245 10.1654 12 9.9101 12 9.64939L11.9937 9.51797C11.9268 8.826 11.3374 8.28483 10.6202 8.28483H9.22015L11.2006 3.65689C11.3394 3.3325 11.4109 2.98387 11.4109 2.63165C11.4109 1.17823 10.2195 0 8.74985 0ZM5.22356 2.33925H8.74985C8.91315 2.33925 9.04552 2.47016 9.04552 2.63165C9.04552 2.67079 9.03758 2.70952 9.02216 2.74557L6.46335 8.7279C6.16647 9.42199 6.49476 10.2227 7.19659 10.5163L7.32637 10.5631C7.45819 10.6034 7.59563 10.6241 7.73414 10.6241H8.81804L5.58438 15.6213L6.17422 12.8546C6.33121 12.1171 5.85397 11.3934 5.10827 11.2382L4.9803 11.2177L4.89132 11.2113C4.87267 11.2105 4.85086 11.2098 4.82402 11.2089H2.65526L4.93746 2.55784C4.97142 2.42909 5.08901 2.33925 5.22356 2.33925Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
